import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const SoundOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function SoundOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="m16.91 22.95-.81-1.83a9.99 9.99 0 0 0 0-18.24l.81-1.83a11.986 11.986 0 0 1 0 21.88v.02Z" />
          <path d="m17.14 18.13-1.27-1.54a5.904 5.904 0 0 0 2.14-4.58c0-1.79-.78-3.46-2.14-4.58l1.27-1.54C18.96 7.39 20 9.62 20 12.01s-1.04 4.62-2.86 6.12Z" />
          <path fillRule="evenodd" clipRule="evenodd" d="M12 2.51h2V21.5h-2l-2.96-2.63a5.445 5.445 0 0 0-3.61-1.37c-3 0-5.43-2.43-5.43-5.43v-.13c0-3 2.43-5.43 5.43-5.43 1.33 0 2.62-.49 3.61-1.37L12 2.51Zm0 16.33V5.19l-1.63 1.45a7.305 7.305 0 0 1-4.94 1.88C3.54 8.52 2 10.06 2 11.95v.13c0 1.89 1.61 3.43 3.43 3.43s3.58.67 4.94 1.88L12 18.84Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default SoundOutlined;